<script lang="ts">
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

  import { InteractiveElement } from "../InteractiveElement";
  import type { BasicCardV2Props } from "./BasicCardV2Props";

  let {
    href = $bindable(undefined),
    base64Href = $bindable(undefined),
    rel = undefined,
    target = undefined,
    asButton = false,
    children,
    ocAriaLabel = undefined,
    Host,
    backgroundColor = undefined,
    elevationLevel = "canvas",
    size = "100",
    fitContent = false,
    inverted = false,
    role = undefined,
    ...rest
  }: BasicCardV2Props = $props();

  /*                                                            */
  let primaryHover = $state(false);
  let primaryActive = $state(false);

  const hoverOn = (ev: Event): void => {
    /*                                 */
    /*                     */
    /*                                         */
    /*                                                                */
    primaryHover =
      !!asButton ||
      !!href ||
      !!base64Href ||
      ev
        .composedPath()
        .some(
          (t) =>
            t instanceof HTMLElement &&
            (t.slot === "primary-action" || t.classList.contains("oc-secondary-action")),
        );
  };

  const hoverOff = (): void => {
    primaryHover = false;
  };

  const activeOn = (ev: Event): void => {
    /*                                  */
    /*                     */
    /*                                         */
    /*                                          */
    if (
      ev
        .composedPath()
        .some((t) => t instanceof HTMLElement && t.classList.contains("oc-secondary-action"))
    ) {
      /*                        */
      primaryActive = false;
    } else {
      primaryActive =
        !!asButton ||
        !!href ||
        !!base64Href ||
        ev.composedPath().some((t) => t instanceof HTMLElement && t.slot === "primary-action");
    }
  };

  const activeOff = (): void => {
    primaryActive = false;
  };
</script>

<svelte:body onmouseup={activeOff} ontouchend={activeOff} ontouchcancel={activeOff} />

<!-- svelte-ignore a11y_mouse_events_have_key_events -->
<article
  class={`card card--elevation-${elevationLevel} card--${size}`}
  class:card--fit-content={fitContent}
  class:card--inverted={inverted}
  class:card--hover={primaryHover}
  class:card--active={primaryActive}
  style:--background-color={backgroundColor}
  onmouseover={hoverOn}
  onmouseleave={hoverOff}
  onmousedown={activeOn}
  ondragend={activeOff}
  ontouchstart={activeOn}
  {role}
>
  <!-- Never ever dare to remove card__interactive. It is used by floating focus to prevent it appearing when using arrow buttons, while focused on a card -->
  <InteractiveElement
    {Host}
    {asButton}
    bind:href
    bind:base64Href
    {rel}
    {target}
    {ocAriaLabel}
    {children}
    {...rest}
    class={`card__interactive ${rest.class ?? ""}`}
  />
</article>

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";
  @use "../../../components/floating-focus/v1/FloatingFocusV1.shared" as floating-focus;
  :global {
    .card {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: var(
        --card-border-radius
      ); /*                                                           */

      &--50 {
        --card-border-radius: #{tokens.$oc-component-card-50-border-radius};
      }

      &--100 {
        --card-border-radius: #{tokens.$oc-component-card-100-border-radius};
      }

      &--elevation-canvas {
        background-color: var(--background-color, tokens.$oc-semantic-color-canvas-background);
        filter: tokens.$oc-semantic-shadow-canvas;
        /*                                             */
      }

      &--elevation-stacked {
        background-color: var(--background-color, tokens.$oc-semantic-color-stacked-background);
        filter: tokens.$oc-semantic-shadow-stacked;
        /*                                             */
      }

      &--elevation-above {
        background-color: var(--background-color, tokens.$oc-semantic-color-above-background);
        filter: tokens.$oc-semantic-shadow-above;
        transform: translateZ(0); /*                                                 */
      }

      &--elevation-sticky {
        background-color: var(--background-color, tokens.$oc-semantic-color-sticky-background);
        filter: tokens.$oc-semantic-shadow-sticky;
        transform: translateZ(0); /*                                                 */
      }

      &--fit-content {
        width: fit-content;
      }

      &--inverted {
        background-color: var(--background-color, tokens.$oc-semantic-color-background-strong-mint);

        & * {
          color: tokens.$oc-semantic-color-text-inverted;
        }

        & * :not(oc-media-object-card-v1) {
          --background-color: tokens.$oc-semantic-color-background-strong-mint;
        }
      }

      @media (hover: hover) {
        &--hover {
          &:after {
            content: "";
            position: absolute;
            inset: var(--card-overlay-inset, 0);
            border-radius: var(--card-border-radius);
            pointer-events: none;
            background-color: tokens.$oc-component-card-overlay-hover;
          }
        }
      }

      &--active {
        &:after {
          content: "";
          position: absolute;
          inset: var(--card-overlay-inset, 0);
          border-radius: var(--card-border-radius);
          pointer-events: none;
          background-color: tokens.$oc-component-card-overlay-active;
        }
      }
    }

    .card__interactive {
      all: unset;
      box-sizing: border-box;
      /*                                                                                   */
      display: block;
      width: 100%;
      max-width: 100%;
      height: 100%;
      border-radius: var(--card-border-radius);
      /*                                                                                                                             */
      overflow: var(--oc-card-overflow, hidden);
      outline: none;
      outline-offset: 0; /*                                        */

      &.-light-dom-interactive {
        pointer-events: none; /*                                     */
      }

      ::slotted([slot="primary-action"]) {
        all: unset;
        position: absolute;
        display: block;
        inset: 0;
        cursor: pointer;
        pointer-events: auto;
        border-radius: var(--card-border-radius);

        @include floating-focus.full-bleed();
      }

      &.-interactive {
        cursor: pointer;
      }
    }
  }
</style>
